import React, { useState, useEffect, useRef } from 'react';
import {auth} from '../firebase-config'
import { db } from '../firebase-config';
import { getDoc, doc } from "firebase/firestore";
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Box from '@mui/material/Box';
import { signInWithPhoneNumber, RecaptchaVerifier } from "firebase/auth";
import { AppCTX } from '../data/AppContext'
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';

export const getUserInfo = async (user) => {
  const querySnapshot = await getDoc(doc(db, "users", user.uid))
  console.log('User found in db', querySnapshot.data());
  if(querySnapshot.data){
    if (typeof localStorage !== 'undefined') {
      // localStorage is supported
      // Continue with your code
      localStorage.setItem('firebase-uid', user.uid);
    } else {
      console.log('COULD NOT STORE IN LOCAL STORAGE');
    }
    return({
      uid: user.uid,
      data: querySnapshot.data()
    });
  }else{
    return({
      uid: user.uid,
      data: null
    })
  }
}

export default function Login () {
  const {setUser} = React.useContext(AppCTX);
  const [phoneNumber, setPhoneNumber] = useState('+1');
  const [verificationCode, setVerificationCode] = useState(['', '', '', '', '', '']);
  const [confirmationResult, setConfirmationResult] = useState(null);
  const [resendCodeTriggered, setResendCode] = useState(0);
  const inputRefs = useRef([]);

  const handlePhoneNumberChange = (e) => {
    if(isNaN(e.target.value))return
    if(e.target.value.length<=12){
      setPhoneNumber(e.target.value);
    }
  };

  const handleVerificationCodeChange = (index, value) => {
    if (isNaN(value)) return; // Only allow numeric input
    const newVerificationCode = [...verificationCode];
    newVerificationCode[index] = value;
    setVerificationCode(newVerificationCode);

    // Auto-focus next input
    if (value !== '' && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && verificationCode[index] === '' && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  useEffect(() => {
    window.recaptchaVerifier = new RecaptchaVerifier('recaptcha-container', {
        'size': 'invisible',
        'callback': (response) => {
          // reCAPTCHA solved, allow signInWithPhoneNumber.
          // onSignInSubmit();
          console.log(response);
        }
      }, auth);
  },[])

  const handleSignIn = () => {
    const appVerifier = window.recaptchaVerifier;
    console.log(appVerifier)
    signInWithPhoneNumber(auth, phoneNumber, appVerifier)
      .then((confirmationResult) => {
        setConfirmationResult(confirmationResult);
      })
      .catch((error) => {
        console.log('Error:', error);
        // window.recaptchaVerifier.reset()
      });
  };

  const handleResendCode = () => {
    setResendCode(resendCodeTriggered+1)
    if(resendCodeTriggered<2){
      handleSignIn()
    }
  }

  const handleConfirmCode = () => {
    confirmationResult
      .confirm(verificationCode.join(''))
      .then((result) => {
        console.log('User signed in:', result.user);
        getUserInfo(result.user).then((info) => {
          setUser(info)
        });
      })
      .catch((error) => {
        console.log('Error:', error);
      });
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100vw',
        background: '#111111',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        p: 0,
        m: 0,
      }}
    >
      <img
        src={process.env.PUBLIC_URL + '/closed.png'}
        alt="Delta Power Group Logo"
        style={{
          width: '220px',
          height: 'auto',
          marginBottom: 32
        }}
      />
      <Box sx={{ width: '90%', maxWidth: 400, mt: 1 }}>
        {confirmationResult?
          <>
            <Typography variant="body1" sx={{ mb: 2, textAlign: 'center', color: '#fff' }}>
              Enter the 6-digit verification code sent to your phone
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
              {verificationCode.map((digit, index) => (
                <TextField
                  key={index}
                  inputRef={(el) => (inputRefs.current[index] = el)}
                  variant="outlined"
                  value={digit}
                  onChange={(e) => handleVerificationCodeChange(index, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(index, e)}
                  inputProps={{
                    maxLength: 1,
                    style: { 
                      textAlign: 'center', 
                      width: '40px', 
                      height: '40px', 
                      fontSize: '1.5rem',
                      margin: '0 4px',
                      color: '#fff',
                    },
                  }}
                  sx={{ width: '50px', mx: 0.5 }}
                />
              ))}
            </Box>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              onClick={handleConfirmCode}
              sx={{ mt: 3, mb: 2 }}
              disabled={verificationCode.join('').length !== 6}
            >
              Confirm Code
            </Button>
            <Link
              component="button"
              variant="body2"
              onClick={handleResendCode}
              sx={{ color: '#fff' }}
            >
              Resend code
            </Link>
          </>
          :
          <>
            <TextField
              margin="normal"
              required
              fullWidth
              id="number"
              label="number"
              name="number"
              autoComplete="phoneNumber"
              inputProps={{inputMode: 'numeric', pattern: '[0-9]*', style: { color: '#fff' } }}
              value={phoneNumber}
              onChange={handlePhoneNumberChange}
              autoFocus
              sx={{
                '& .MuiInputBase-root': {
                  color: '#fff',
                },
                '& .MuiInputLabel-root': {
                  color: '#fff',
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#fff',
                },
              }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              onClick={handleSignIn}
              sx={{ mt: 3, mb: 2 }}
            >
              Send Verification Code
            </Button>
          </>
        }
      </Box>
      <div id="recaptcha-container"></div>
    </Box>
  );
};
